<template>
    <div class="one-theme"
        @click="clickOneTheme()"
        :style="{ 
            backgroundImage: `url(${imgLocal})`,
            backgroundPosition: 'center center', 
            backgroundSize: 'cover' 
        }"
    >
        <div class="one-theme__title">
            {{text}}
        </div>
    </div>
</template>

<script>
    export default {
        props: [
           'text',
           'id',
           'img',
           'index',
           'coef'
        ],
        computed: {
            imgLocal() {
                try {
                  if(this.img) {
                    if(this.img.indexOf('http') === 0) {
                      return this.img
                    } else {
                      return require('~/assets/not-image.svg')
                    }
                  } else {
                    return require('~/assets/not-image.svg')
                  }

                } catch(e) {
                    console.error(e)
                    return false
                }
            }
        },
        methods: {
            async clickOneTheme() {
                await this.$emit('clickOneTheme', {
                    id: this.id,
                    text: this.text,
                    img: this.img,
                    index: this.index,
                    coef: this.coef
                })
            }
        }
    }
</script>

<style lang="less">
    .one-theme {
        max-width: 150px;
        width: 100%;
        height: 150px;
        border-radius: 15px;
        //padding: 0px 16px 0px 16px;
        display: flex;
        justify-content: center;
        margin: 5px;
        cursor: pointer;

    }

    .one-theme__title {
        font-family: 'Montserrat-Bold';
        font-size: 18px;
        margin-top: 20px;
        line-height: 20px;
        text-align: center;
        color: #FFFFFF
    }
</style>